
import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GROUPS_QUERY } from '../../queries/ROSTER_GROUPS_QUERY';

export function useRosterGroupsQuery( options ) {
    const { data: rawData, loading, error, refetch } = useQuery( GROUPS_QUERY, {
        fetchPolicy: 'cache-first',
        ...options,
    } );

    return useMemo ( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ rawData, loading, error, refetch ] );
}
